"use client"

import Login from "./login/page";

export default function Home() {
  return <Login />;
}



// "use client"
// import { useEffect, useState } from "react";
// import * as Constants from '@/utils/Constants/constants';
// import { redirect } from "next/navigation";
// import { useCookies } from "next-client-cookies";
// import Loading from "./loading";
// import Login from "./login/page";

// export default function Home() {
//   const cookieStore = useCookies();
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     const isLoggedIn = cookieStore.get(Constants.LOGIN_USR_STTS_KEY);
//     const uLX11 = cookieStore.get('uLXizdwd-a');
//     const redirectUserType = cookieStore.get("ACCESS_TYPE");

//     if (isLoggedIn && isLoggedIn === Constants.LOGIN_USR_STTS_VAL_ACTIVE && uLX11?.charAt(0) === "1") {
      // if (redirectUserType === "RECON_SETTLE") {
      //   redirect("/user/merchant/upload-mpr");
      // } else if (redirectUserType === "BO_USER" || redirectUserType === "BO_SUPERVISOR") {
      //   redirect("/user/dashboard");
      // } else if (redirectUserType === "AP_SUPERUSER") {
      //   redirect("/user/merchant/active-merchant");
      // } else {
      //   redirect("/user/merchant/transaction-dashboard");
      // }
//     } else {
//       setIsLoading(false);
//     }
//   }, [cookieStore]);


//   if (isLoading) {
//     return <Loading />;
//   }

//   return <Login />;

// }